<homefield-icon name="{{icon}}" width="44px" height="44px"></homefield-icon>
<p class="hmf-header-bold-s hmf-mt-xs hmf-mb-0">{{title}}</p>
<p class="hmf-body-m hmf-mt-xxs hmf-mb-0">{{description}}</p>